import { render, staticRenderFns } from "./EduSessions.vue?vue&type=template&id=9278d9de"
import script from "./EduSessions.vue?vue&type=script&lang=js"
export * from "./EduSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports